import React from 'react';
import LegalPage, { H2, P, A } from './LegalPage';

const PrivacyPolicy = () => (
  <LegalPage title="Privacy Policy" updated="June 13, 2026">
    <P>
      This Privacy Policy explains how Influencer.in (“we”, “us”) collects, uses, stores and protects
      your information when you use our platform and services. By using Influencer.in you agree to the
      practices described here.
    </P>

    <H2>Information We Collect</H2>
    <P>
      We collect information you provide when you create an account or use the platform (such as name,
      email, company details), information generated through your use of the service, and data from
      third-party platforms you choose to connect (such as YouTube, Instagram). We also collect usage
      and device information through cookies and similar technologies.
    </P>

    <H2>How We Use Your Information</H2>
    <P>
      We use your information to provide and improve the service, deliver analytics and reporting,
      personalise your experience, communicate with you, and comply with our legal obligations. We do
      not sell your personal information.
    </P>

    <H2>Use of YouTube API Services</H2>
    <P>
      Certain features of Influencer.in use <strong>YouTube API Services</strong> to retrieve and
      display YouTube data (such as channel statistics, video performance, audience metrics, and
      content insights) on behalf of users who connect their YouTube or Google account.
    </P>
    <P>
      By using these features, you agree to be bound by the{' '}
      <A href="https://www.youtube.com/t/terms">YouTube Terms of Service</A>.
    </P>
    <P>
      Our access to and use of YouTube data is also governed by the{' '}
      <A href="https://policies.google.com/privacy">Google Privacy Policy</A>.
    </P>
    <P>
      <strong>What we access:</strong> With your authorization, we access YouTube channel and video data
      via the YouTube Data API solely to provide analytics, reporting, and campaign features within
      Influencer.in. We do not use YouTube data for advertising, and we do not sell it.
    </P>
    <P>
      <strong>Storage &amp; retention:</strong> Authorized YouTube data is stored securely and retained
      only for as long as your account is active or as needed to provide the service. Cached YouTube data
      is refreshed or deleted in accordance with the YouTube API Services Terms.
    </P>
    <P>
      <strong>Deleting your data:</strong> You may request deletion of stored YouTube data at any time by
      emailing <A href="mailto:enquiry@influencer.in">enquiry@influencer.in</A>. We will delete the
      relevant data from our systems upon request, subject to legal retention obligations.
    </P>
    <P>
      <strong>Revoking access:</strong> You can revoke Influencer.in’s access to your YouTube/Google data
      at any time through the Google security settings page:{' '}
      <A href="https://myaccount.google.com/permissions">https://myaccount.google.com/permissions</A>.
      Revoking access stops further data collection; previously stored data can be deleted using the
      email request above.
    </P>

    <H2>Sharing of Information</H2>
    <P>
      We may share information with service providers who perform services on our behalf, when required
      by law, or in connection with a business transfer. These parties are bound to protect your
      information and use it only for the purposes we specify.
    </P>

    <H2>Data Security</H2>
    <P>
      We use commercially reasonable technical and organisational measures to protect your information.
      No method of transmission or storage is completely secure, but we work to safeguard your data.
    </P>

    <H2>Accessing, Updating and Deleting Your Information</H2>
    <P>
      You may access, correct, or delete your personal information (to the extent allowed by law) by
      managing your account or by emailing <A href="mailto:enquiry@influencer.in">enquiry@influencer.in</A>.
    </P>

    <H2>Children</H2>
    <P>The platform is not directed to children under 13, and we do not knowingly collect their data.</P>

    <H2>Changes to This Policy</H2>
    <P>
      We may update this Privacy Policy from time to time. Material changes will be reflected by updating
      the “Last updated” date above.
    </P>

    <H2>Contact Us</H2>
    <P>
      For any questions about this Privacy Policy, contact us at{' '}
      <A href="mailto:enquiry@influencer.in">enquiry@influencer.in</A>.
    </P>
  </LegalPage>
);

export default PrivacyPolicy;
